// TRAIL — timeline / steps. Questions as numbered stops on a vertical
// timeline: a round accent-tinted number badge, a hairline connector, and
// the answer alongside. Staggered entrance reveal.
function itemHtml(ctx, it) {
    return `<div class="fq-step"${ctx.reveal(it.idx)}>
  <div class="fq-rail">
    <span class="fq-badge">${it.num}</span>
    <span class="fq-line"></span>
  </div>
  <div class="fq-body">
    <h3 class="fq-q">${it.q}</h3>
    <div class="fq-a">${it.aHtml}</div>
  </div>
</div>`;
}
const trail = {
    id: 'trail',
    name: 'Trail',
    tag: 'Timeline steps',
    styleTag: 'Guided',
    description: 'Questions as numbered steps on a vertical timeline. Perfect when your FAQ is really a process \u2014 onboarding, ordering, getting started.',
    layout: 'list',
    defaultAccent: '#0e8f7e',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:640px;margin:0 auto}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 34px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-list{display:flex;flex-direction:column}
.FQM .fq-step{display:grid;grid-template-columns:34px minmax(0,1fr);gap:0 18px}
.FQM .fq-rail{display:flex;flex-direction:column;align-items:center}
.FQM .fq-badge{flex:0 0 auto;display:grid;place-items:center;width:34px;height:34px;border-radius:999px;background:${ctx.v.soft};color:${ctx.v.accent};font-size:13px;font-weight:700}
.FQM .fq-line{flex:1;width:2px;background:${ctx.v.border};margin:6px 0}
.FQM .fq-body{padding-bottom:30px}
.FQM .fq-q{margin:5px 0 7px;font-size:17px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15px;line-height:1.65;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default trail;
